<template>
  <div class="flex-col gap-y-md">
    <dd-header-card header="Algemene instellingen">
      <GeneralSettings/>
    </dd-header-card>
    <ChooseAutomationActions/>
  </div>
</template>

<script>
import ConfigureSignalSettingsComponent from '../ConfigureSignalSettingsComponent.vue'
import ConfigureTaskSettingsComponent from '../ConfigureTaskSettingsComponent.vue'
import ConfigureEmailSettingsComponent from '../ConfigureEmailSettingsComponent.vue'
import ConfigureCampaignSettingsComponent from '../ConfigureCampaignSettingsComponent.vue'
import ChooseAutomationActions from '../ChooseAutomationActions.vue'
import { mapFields } from "vuex-map-fields";
import GeneralSettings from '../GeneralSettings.vue'
export default {
  name: "CampaignSettingsStep.vue",
  components: {
    ChooseAutomationActions,GeneralSettings,
    ConfigureTaskSettingsComponent,
    ConfigureSignalSettingsComponent,
    ConfigureEmailSettingsComponent,
    ConfigureCampaignSettingsComponent,
  },
  computed: {
    ...mapFields(`$_automation`, [
        'creatingAutomation.create_task',
        'creatingAutomation.create_signal',
        'creatingAutomation.send_email',
        'creatingAutomation.type',
    ]),
  }
};
</script>

<style scoped>

</style>
